import Button from "@mui/material/Button";

import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { reloadWithFreshShell } from "~lib/reloadWithFreshShell.ts";

export function ReloadButton() {
  const t = useTranslation();

  return (
    <Button variant="contained" onClick={() => void reloadWithFreshShell()}>
      {t.genericErrorPageReload}
    </Button>
  );
}
